// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.order.VisionWebSupplierResponse */
/* istanbul ignore next */
@GandalfModel
export class VisionWebSupplierResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	externalIdentifier!: string | null;

	@GandalfProperty({ designType: String })
	name!: string | null;

	@GandalfConstantDecorator(constants.OrderVendorType)
	@GandalfProperty({ designType: constants.OrderVendorType })
	orderVendorType!: constants.OrderVendorType | null;

}
